function saveWishlistStorage(value) {
	localStorage.setItem('wish_list', JSON.stringify(value));
}

function saveCartStorage(value) {
	localStorage.setItem('cart', JSON.stringify(value));
}

function getWishlistStorage() {
	const wishList = localStorage.getItem('wish_list');
	return JSON.parse(wishList);
}

function getCartStorage() {
	const cart = localStorage.getItem('cart');
	return JSON.parse(cart);
}

export {
	saveWishlistStorage,
	saveCartStorage,
	getWishlistStorage,
	getCartStorage,
};
